import { render, staticRenderFns } from "./ps11.vue?vue&type=template&id=ae58def6&scoped=true&"
import script from "./ps11.vue?vue&type=script&lang=js&"
export * from "./ps11.vue?vue&type=script&lang=js&"
import style0 from "./ps11.vue?vue&type=style&index=0&id=ae58def6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae58def6",
  null
  
)

export default component.exports